import React, {Suspense, lazy} from 'react';
import {
  ROUTE_DR_POTENTIAL_SUMMARY_REPORT,
} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const DrPotentialSummaryReport = lazy(() =>
  import('../../../screens/DrPotentialSummaryReport')
    .then(module => ({default: module.DrPotentialSummaryReport})));

const DrPotentialSummaryReportNavigation = [
  {
    path: ROUTE_DR_POTENTIAL_SUMMARY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DrPotentialSummaryReport />
      </Suspense>
    ),
  },
];

export default DrPotentialSummaryReportNavigation;
